import React from 'react';
import cx from 'classnames';
import {HyperlinkText} from '../../../../components/Common/LinkTexts/LinkTexts';
import style from './style.module.scss';
import {IsJsonString} from '../../../../utils/proto-api-utils/utils';

type Props = {
    text: string;
    onClick?: (linkData: any) => void;
};

type HyperLinkDataType = {
    from: string;
    len: string;
    title: string;
    ename: string;
    type: string;
};

function mapLinkData(data?: HyperLinkDataType) {
    if (data) {
        return [
            {
                from: parseInt(data.from) || 0,
                len: parseInt(data.len) || 0,
                title: data.title || '',
                linkData: {
                    type: data.type || '',
                    eName: data.ename || ''
                }
            }
        ];
    }
    return [];
}

export const FormHyperLinkText = ({text, onClick}: Props) => {
    const isValidJson = IsJsonString(text);
    if (isValidJson) {
        const data = JSON.parse(text)[0];
        const mappedLinkData = mapLinkData(data.HyperLinks[0]);

        return (
            <HyperlinkText
                componentClasses={cx(style.component, style.padding_0)}
                text={data.text}
                linkData={mappedLinkData}
                onLinkClick={onClick}
            />
        );
    }
    return <span>{text}</span>;
};
